<template>
  <nav v-if="pager?.length" class="ui-pagination" aria-label="Pagination">
    <button
      v-for="(page, index) in pager"
      :key="`${page.label}-${index}`"
      type="button"
      class="ui-pagination-item"
      :class="{ 'is-active': page.active }"
      :disabled="!page.url"
      :aria-current="page.active ? 'page' : undefined"
      :aria-label="pageLabel(page)"
      @click="emitPage(pageTarget(page))"
    >
      <ChevronLeft v-if="page.label.includes('Previous')" :size="16" aria-hidden="true" />
      <ChevronRight v-else-if="page.label.includes('Next')" :size="16" aria-hidden="true" />
      <span v-else>{{ page.label }}</span>
    </button>
  </nav>
</template>

<script>
import { ref, watchEffect } from "vue";
import { ChevronLeft, ChevronRight } from "@lucide/vue";
import pageControl from "@/composables/pageControl";

export default {
  name: "PaginationComponent",
  components: { ChevronLeft, ChevronRight },
  emits: ["newPage"],
  props: ["payLoad"],
  setup(props, context) {
    const pager = ref(null);
    const pageNext = ref(null);
    const pagePrevious = ref(null);
    const pageCurr = ref(0);
    const pageTotal = ref(0);

    watchEffect(() => {
      const state = pageControl(props.payLoad);
      if (!state.pagerPc.value) return;
      pager.value = state.pagerPc.value;
      pageCurr.value = state.pageCurrPc.value;
      pageNext.value = state.pageNextPc.value;
      pagePrevious.value = state.pagePreviousPc.value;
      pageTotal.value = state.pageTotalPc.value;
    });

    const pageTarget = (page) => {
      if (page.label.includes("Previous")) return pagePrevious.value;
      if (page.label.includes("Next")) return pageNext.value;
      return page.label;
    };
    const pageLabel = (page) => {
      if (page.label.includes("Previous")) return "Previous page";
      if (page.label.includes("Next")) return "Next page";
      return `Page ${page.label}`;
    };
    const emitPage = (page) => { if (page) context.emit("newPage", page); };

    return { emitPage, pageLabel, pageTarget, pager };
  },
};
</script>

<style scoped>
.ui-pagination {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  justify-content: center;
  padding: 1.25rem 0;
}
.ui-pagination-item {
  align-items: center;
  background: var(--ui-background);
  border: 1px solid var(--ui-border);
  border-radius: calc(var(--ui-radius) - 3px);
  color: var(--ui-muted-foreground);
  cursor: pointer;
  display: inline-flex;
  font-size: 0.78rem;
  font-weight: 600;
  height: 2.15rem;
  justify-content: center;
  min-width: 2.15rem;
  padding: 0 0.55rem;
}
.ui-pagination-item:hover:not(:disabled) { background: var(--ui-accent); color: var(--ui-accent-foreground); }
.ui-pagination-item.is-active { background: var(--ui-primary); border-color: var(--ui-primary); color: var(--ui-primary-foreground); }
.ui-pagination-item:disabled { cursor: not-allowed; opacity: 0.42; }
</style>
